import Loadable from 'react-loadable';
import LoadingBar from '../../ProgressLoader';

export default Loadable({
    loader: () => import('./SponsorChooser'),
    loading: LoadingBar
});

